import { CommandBase } from "../../../common/services/cqs/commandManager";

export class SetVardekapCommand extends CommandBase {
    arbetsorderId: number;
    vardekap: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetVardekapCommand";

    constructor(init: (instance: SetVardekapCommand) => void) {
        super(SetVardekapCommand.$type);
        init(this);
    }
}
